module.exports = __webpack_public_path__ + "img/flat.fb0c8529.svg";